/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CheckInviteTokenOptions, CheckInviteTokenResponses } from '../../models/CheckInviteToken'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Check Invite Token
 * {@link /check-invite-token}
 */
export function checkInviteToken<ThrowOnError extends boolean = true>(options: Options<CheckInviteTokenOptions, ThrowOnError> = {}): Promise<UnwrappedResult<CheckInviteTokenResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/check-invite-token', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CheckInviteTokenResponses, ThrowOnError>>
}
